import React from 'react';
import './LandingPage.css';

const LandingPage = ({ onFeatureSelect, userInfo, onLogout }) => {
  const features = [
    {
      id: 'pdf-extractor',
      title: 'PDF Extractor',
      description: 'Multi-purpose PDF extraction with profile/mode controls and DB-backed results',
      icon: '🧩',
      status: 'Available',
      color: '#1f7a8c'
    },
    {
      id: 'engagement-manager',
      title: 'Engagement Manager',
      description: 'Create and manage SOC 2 engagements with 6-phase lifecycle tracking',
      icon: '📂',
      status: 'Available',
      color: '#e74c3c'
    },
    {
      id: 'document-intake',
      title: 'Document Intake',
      description: 'Upload, parse and validate client documents for SOC 2 engagements',
      icon: '📥',
      status: 'Available',
      color: '#3498db'
    },
    {
      id: 'soc-analyzer',
      title: 'SOC Analyzer',
      description: 'AI-powered SOC 2 compliance analysis and document comparison',
      icon: '🔍',
      status: 'Available',
      color: '#007bff'
    },
    {
      id: 'planning',
      title: 'Planning',
      description: 'SOC-2 Planning Phase Risk Assessment with AI-powered workflow',
      icon: '📋',
      status: 'Available',
      color: '#28a745'
    },
    {
      id: 'compliance-tracker',
      title: 'Compliance Tracker',
      description: 'Multi-framework compliance monitoring and tracking',
      icon: '📊',
      status: 'Coming Soon',
      color: '#6c757d'
    },
    {
      id: 'audit-manager',
      title: 'Audit Manager',
      description: 'Complete audit lifecycle management and documentation',
      icon: '📝',
      status: 'Coming Soon',
      color: '#6c757d'
    },
    {
      id: 'policy-generator',
      title: 'Policy Generator',
      description: 'AI-assisted security policy creation and customization',
      icon: '📄',
      status: 'Coming Soon',
      color: '#6c757d'
    },
    {
      id: 'vendor-assessment',
      title: 'Vendor Assessment',
      description: 'Third-party security assessment and vendor management',
      icon: '🤝',
      status: 'Coming Soon',
      color: '#6c757d'
    }
  ];
  const featureToModule = {
    'pdf-extractor': 'pdf_extractor',
    'engagement-manager': 'engagement_manager',
    'document-intake': 'document_intake',
    'soc-analyzer': 'soc_analyzer',
    'planning': 'planning',
    'compliance-tracker': 'compliance_tracker',
    'audit-manager': 'audit_manager',
    'policy-generator': 'policy_generator',
    'vendor-assessment': 'vendor_assessment',
  };
  const moduleAccess = userInfo?.module_access || null;
  const normalizedRole = (userInfo?.role || '').toLowerCase();
  const visibleFeatures = features.filter((feature) => {
    if (feature.status !== 'Available') return true;
    if (moduleAccess && typeof moduleAccess === 'object') {
      if (moduleAccess['*']) return true;
      const key = featureToModule[feature.id];
      return Boolean(moduleAccess[key]);
    }
    // Fallback compatibility behavior if module_access is not present.
    if (normalizedRole === 'pdf_extractor') {
      return feature.id === 'pdf-extractor';
    }
    return true;
  });

  return (
    <div className="landing-page">
      <header className="landing-header">
        <div className="header-content">
          <div className="header-left">
            <h1 className="main-title">4CISO Platform</h1>
            <p className="main-subtitle">
              Comprehensive cybersecurity and compliance management suite
            </p>
          </div>
          <div className="header-right">
            {userInfo && (
              <div className="user-info">
                <span className="user-name">Welcome, {userInfo.name}</span>
                <button onClick={onLogout} className="logout-button">
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      <main className="features-section">
        <div className="features-container">
          <h2 className="features-title">Select a Feature</h2>
          <div className="features-grid">
            {visibleFeatures.map((feature) => (
              <div
                key={feature.id}
                className={`feature-card ${feature.status === 'Available' ? 'available' : 'coming-soon'}`}
                onClick={() => feature.status === 'Available' && onFeatureSelect(feature.id)}
                style={{ borderColor: feature.color }}
              >
                <div className="feature-icon" style={{ color: feature.color }}>
                  {feature.icon}
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
                <div className={`feature-status ${feature.status === 'Available' ? 'available' : 'coming-soon'}`}>
                  {feature.status}
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      <footer className="landing-footer">
        <div className="footer-content">
          <p>&copy; 2024 4CISO Platform. Professional cybersecurity compliance solutions.</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage; 
